// Action creators for the commission rules slice.
// One shared factory, one line per action.

import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

export var getCommissionRulesRequest =
  creator(types.GET_COMMISSION_RULES_REQUEST);
export var getCommissionRulesSuccess =
  creator(types.GET_COMMISSION_RULES_SUCCESS);
export var getCommissionRulesFailed =
  creator(types.GET_COMMISSION_RULES_FAILURE);

export var getCommissionRuleRequest =
  creator(types.GET_COMMISSION_RULE_REQUEST);
export var getCommissionRuleSuccess =
  creator(types.GET_COMMISSION_RULE_SUCCESS);
export var getCommissionRuleFailed =
  creator(types.GET_COMMISSION_RULE_FAILURE);

export var createCommissionRuleRequest =
  creator(types.CREATE_COMMISSION_RULE_REQUEST);
export var createCommissionRuleSuccess =
  creator(types.CREATE_COMMISSION_RULE_SUCCESS);
export var createCommissionRuleFailed =
  creator(types.CREATE_COMMISSION_RULE_FAILURE);
export var resetCreateCommissionRuleSuccess =
  creator(types.RESET_CREATE_COMMISSION_RULE_SUCCESS);
export var resetCreateCommissionRuleError =
  creator(types.RESET_CREATE_COMMISSION_RULE_ERROR);

export var updateCommissionRuleRequest =
  creator(types.UPDATE_COMMISSION_RULE_REQUEST);
export var updateCommissionRuleSuccess =
  creator(types.UPDATE_COMMISSION_RULE_SUCCESS);
export var updateCommissionRuleFailed =
  creator(types.UPDATE_COMMISSION_RULE_FAILURE);
export var resetUpdateCommissionRuleSuccess =
  creator(types.RESET_UPDATE_COMMISSION_RULE_SUCCESS);
export var resetUpdateCommissionRuleError =
  creator(types.RESET_UPDATE_COMMISSION_RULE_ERROR);

// Payload: { symbols, formulas } — flat, unlike the clawback equivalent.
// Results come back in cents.
export var validateCommissionRuleRequest =
  creator(types.VALIDATE_COMMISSION_RULE_REQUEST);
export var validateCommissionRuleSuccess =
  creator(types.VALIDATE_COMMISSION_RULE_SUCCESS);
export var validateCommissionRuleFailed =
  creator(types.VALIDATE_COMMISSION_RULE_FAILURE);
export var resetValidateCommissionRule =
  creator(types.RESET_VALIDATE_COMMISSION_RULE);

export var setCommissionRuleToEdit =
  creator(types.SET_COMMISSION_RULE_TO_EDIT);
export var resetCommissionRuleToEdit =
  creator(types.RESET_COMMISSION_RULE_TO_EDIT);
